import React, { useEffect, useState } from 'react';
import { Icon, Modal } from 'merchant-portal-components';
import { renderTextField } from '../../../components/FormElements/ReduxForm';
import { reduxForm, Field, change } from 'redux-form';
import * as actions from '../actions';
import { connect } from 'react-redux';
import { Button, ButtonRow } from 'merchant-portal-components';
import styled from 'styled-components';
import Alert from '../../Alert/Alert';
import ReactGA from 'react-ga';
import { InputAdornment, TextField } from '@material-ui/core';
import { useAppCode } from '../../../hooks/use-app-code';

const Wrapper = styled.div`
  width: 400px;
  background: white;
  padding: 16px;
`;

const StyledForm = styled.form`
  display: grid;
  grid-gap: 10px;
`;

let AuthenticateModal = (props) => {
  const { accountReducer, handleSubmit } = props;
  const { isRouteUpdatedByAppCode } = props.accountReducer;
  const isButtonLoading = props.accountReducer.isSigningIn;

  const [appCodeTouched, setAppCodeTouched] = useState(false);
  const { appCode, handleAppCodeChange } = useAppCode(props.getAppBaseURL);

  // reset password
  if (accountReducer.shouldClearOnError) {
    props.dispatch(change('reAuthenticate', 'password', ''));
  }

  const handleFormSubmit = (formProps) => {
    ReactGA.event({
      category: 'Click',
      action: 'Login',
      label: 'Login',
    });
    props.signinUser(formProps);
  };

  return (
    <Modal>
      <Alert />
      <Wrapper>
        <p style={{ fontWeight: '600', marginBottom: '24px' }}>
          Session expired. Please Re-Authenticate.
        </p>
        <StyledForm name='signin' onSubmit={handleSubmit(handleFormSubmit)}>
          <TextField
            id='Login-appCode'
            variant='outlined'
            value={appCode}
            onChange={handleAppCodeChange}
            placeholder='App Code'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Icon className={'fas fa-laptop-code'} />
                </InputAdornment>
              ),
            }}
            label='App Code'
            type='text'
            style={{ height: '48px', marginBottom: '22px' }}
            onBlur={() => setAppCodeTouched(true)}
            error={!appCode && appCodeTouched}
            helperText={!appCode && appCodeTouched ? 'Required' : ''}
            margin='normal'
          />
          <Field
            name='email'
            label='Username'
            type='text'
            component={renderTextField}
            placeholder='Username'
            icon='fa fa-user'
            className='form-control'
            disabled={!isRouteUpdatedByAppCode}
          />
          <Field
            name='password'
            label='Password'
            type='password'
            password
            className='form-control'
            component={renderTextField}
            icon='fa fa-key'
            placeholder='Password'
            disabled={!isRouteUpdatedByAppCode}
          />
          <ButtonRow justifyContent='flex-end'>
            <Button
              type='submit'
              disabled={isButtonLoading || !isRouteUpdatedByAppCode}
            >
              Login
            </Button>
          </ButtonRow>
        </StyledForm>
      </Wrapper>
    </Modal>
  );
};

function validate(formProps) {
  const errors = {};
  if (!formProps.email) {
    errors.email = 'Required Username';
  }
  if (!formProps.password) {
    errors.password = 'Required Password';
  }
  return errors;
}

function mapStateToProps(state) {
  return {
    accountReducer: state.accountReducer,
  };
}

AuthenticateModal = reduxForm({
  form: 'reAuthenticate',
  validate,
})(AuthenticateModal);

AuthenticateModal = connect(mapStateToProps, actions)(AuthenticateModal);

export default AuthenticateModal;
